import { DefineDevice, JingTaiMg75Devices, KIO, KeyMap, OutputMode, Record, VirtualMu68Pro, VirtualMu68Pro_Cyan, VirtualMu68_ULTRA, VirtualNa87ProWired, VirtualNd63, VirtualNd63_Cyan, VirtualPolar75, JingTaiMer68Devices } from '@hid/define/define'
import { DeviceMapKey } from './device'
import { dataProfileManage } from '@hid/snapshot/profile'
import { DVKFromVK, HIDFromVk } from '@hid/define/define_fn'
import { splitIntoBytes } from '../tool'
import defineType from '@hid/define/define_type'
import { KK } from '@/define/define'
import { isDeviceFunctionActionKey } from '@/define/internal_action_keys'
import { getJingtaiV1RawCodeByActionKey } from './registry/jingtai_v1'
import { FNVK } from '@hid/define/define_keys'

class Na87 implements DeviceMapKey {
  encodeKey(params: KIO): KeyMap {
    if (params.Output.Mode != OutputMode.Key) {
      throw new Error('Not Key Mode')
    }

    let layout = na87Layout.FN0
    if (params.Input.WithFN) {
      layout = na87Layout.FN1
    }

    if (defineType.isMedia(params.Output.VK) || defineType.isMouse(params.Output.VK) || params.Output.VK == FNVK) {
      const dvk = DVKFromVK(params.Output.VK, VirtualNa87ProWired)
      const [consumerLowByte, consumerHighByte] = splitIntoBytes(dvk)
      return [params.Input.KK, layout, consumerLowByte, consumerHighByte]
    }

    if (isDeviceFunctionActionKey(params.Output.VK)) {
      const rawCode = getJingtaiV1RawCodeByActionKey(params.Output.VK)
      if (rawCode == undefined) {
        throw new Error('Not Found Device Function : ' + params.Output.VK)
      }

      const [rawCodeLowByte, rawCodeHighByte] = splitIntoBytes(rawCode)
      return [params.Input.KK, layout, rawCodeLowByte, rawCodeHighByte]
    }

    let setKey = HIDFromVk(params.Output.VK)
    if (setKey == undefined) {
      throw new Error('Not Found Key : ' + params.Output.VK)
    }

    return [params.Input.KK, layout, setKey, 0x00]
  }

  macroData(params: KIO): number[] {
    const macro = dataProfileManage().dataProfile.Macros.get(params.Output.DataIndex)
    if (macro == undefined) {
      throw new Error('macro is undefined')
    }

    const data = Array(11).fill(0)

    //data[0] = params.Input.KK;
    data[0] = na87Layout.MODE
    data[1] = na87SetMode.Macro
    data[2] = 0x00

    data[3] = params.Input.KK
    data[4] = na87Layout.Macro_addr
    data[5] = params.Output.DataIndex
    data[6] = 0x00

    data[7] = params.Input.KK
    data[8] = na87Layout.Macro_long
    data[9] = macro.length
    data[10] = 0x00

    return data
  }

  macroDataConfig(params: KIO): number[] {
    const macro = dataProfileManage().dataProfile.Macros.get(params.Output.DataIndex)
    if (macro == undefined) {
      throw new Error('macro is undefined')
    }

    let count = 1
    if (params.Output.Extension[0] > 1) {
      count = 65535
    } else if (params.Output.Extension[0] == 1) {
      count = params.Output.Extension[1]
    }

    console.log('params', params)

    let mode = params.Output.Extension[0]
    if (params.Output.Extension[0] == 2) {
      mode = 1
    }
    if (params.Output.Extension[0] == 3) {
      mode = 2
    }

    const [consumerLowByte, consumerHighByte] = splitIntoBytes(count) //max 65530
    const data = Array(8).fill(0)

    data[0] = params.Output.DataIndex
    data[1] = 0x00
    data[2] = macro.length

    data[3] = mode // 宏循环方式
    data[4] = consumerLowByte // 重复次数
    data[5] = consumerHighByte

    data[6] = 0x01 // 重复间隔
    data[7] = 0x00
    data[8] = 0x00

    return data
  }

  genarateMacroData(data: Record, keyDataLen: number): number[] {
    let key = HIDFromVk(data.Key)
    if (defineType.isMouse(data.Key)) {
      key = DVKFromVK(data.Key, VirtualNa87ProWired)
    }
    if (key == undefined) {
      throw new Error('Not Found Key : ' + data.Key)
    }

    const data16bit_low: number = key & 0xff
    const data16bit_high: number = (key >> 8) & 0xff

    const keyState: number = data.Press ? 1 : 8
    const keyDelay: number = data.Delay

    const buffer = new ArrayBuffer(keyDataLen)
    const view = new DataView(buffer)

    view.setUint8(0, data16bit_low)
    view.setUint8(1, data16bit_high)

    if (keyDataLen == 6) {
      const combined = (keyState << 24) | keyDelay
      view.setUint8(2, combined & 0xff)
      view.setUint8(3, (combined >> 8) & 0xff)
      view.setUint8(4, (combined >> 16) & 0xff)
      view.setUint8(5, (combined >> 24) & 0xff)
    } else {
      // 将 4bit 数据和 12bit 数据组合成 16bit 数据
      const combined = (keyState << 12) | keyDelay
      view.setUint8(2, combined & 0xff)
      view.setUint8(3, (combined >> 8) & 0xff)
    }

    return Array.from(new Uint8Array(buffer))
  }

  private Mu68ProFnDisableKeys: Map<number, number[]> = new Map([
    [41, [53, 0]],
    [44, [3, 240]],
    [75, [16, 243]],
    [80, [21, 243]],
    [82, [18, 243]],
    [79, [20, 243]],
    [81, [19, 243]],
    [73, [23, 243]],
    [76, [17, 243]],
    [39, [67, 0]],
    [30, [58, 0]],
    [31, [59, 0]],
    [32, [60, 0]],
    [33, [61, 0]],
    [34, [62, 0]],
    [35, [63, 0]],
    [36, [64, 0]],
    [37, [65, 0]],
    [38, [66, 0]],
    [19, [71, 0]],
    [22, [2, 241]],
    [227, [9, 243]],
    [228, [2, 240]],
    [51, [70, 0]],
    [46, [69, 0]],
    [45, [68, 0]],
    [47, [74, 0]],
    [48, [77, 0]],
    [52, [72, 0]],
  ])

  private Na87ProFnDisableKeys: Map<number, number[]> = new Map([
    [58, [148, 17]],
    [59, [35, 18]],
    [60, [138, 17]],
    [61, [131, 17]],
    [62, [182, 16]],
    [63, [181, 16]],
    [64, [205, 16]],
    [65, [183, 16]],
    [66, [233, 16]],
    [67, [234, 16]],
    [68, [226, 16]],
    [69, [146, 17]],
    [71, [16, 243]],
    [73, [17, 243]],
    [76, [0, 241]],
    [82, [18, 243]],
    [80, [21, 243]],
    [81, [19, 243]],
    [79, [20, 243]],
    [4, [1, 241]],
    [22, [2, 241]],
    [227, [9, 243]],
  ])

  private ND63FnDisableKeys: Map<KK, number[]> = new Map([
    [0x29, [0x35, 0x00]], // esc
    [0x1e, [0x3a, 0x00]], // 1
    [0x1f, [0x3b, 0x00]], // 2
    [0x20, [0x3c, 0x00]], // 3
    [0x21, [0x3d, 0x00]], // 4
    [0x22, [0x3e, 0x00]], // 5
    [0x23, [0x3f, 0x00]], // 6
    [0x24, [0x40, 0x00]], // 7
    [0x25, [0x41, 0x00]], // 8
    [0x26, [0x42, 0x00]], // 9
    [0x27, [0x43, 0x00]], // 0
    [0x2d, [0x44, 0x00]], // -
    [0x2e, [0x45, 0x00]], // =

    [0x15, [0x10, 0xf3]], // r
    [0x17, [0x11, 0xf3]], // t
    [0xe3, [0x09, 0xf3]], // WIN
    [0x52, [0x12, 0xf3]], // UP
    [0x50, [0x15, 0xf3]], // LEFT
    [0x51, [0x13, 0xf3]], // center
    [0x4f, [0x14, 0xf3]], // right
    [0xe6, [0x02, 0xf0]], // RAlt
  ])

  private Mu68ULTRAFnDisableKeys: Map<KK, number[]> = new Map([
    [75, [16, 243]],
    [80, [21, 243]],
    [82, [18, 243]],
    [79, [20, 243]],
    [81, [19, 243]],
    [73, [23, 243]],
    [76, [17, 243]],

    [30, [58, 0]],
    [31, [59, 0]],
    [32, [60, 0]],
    [33, [61, 0]],
    [34, [62, 0]],
    [35, [63, 0]],
    [36, [64, 0]],
    [37, [65, 0]],
    [38, [66, 0]],
    [39, [67, 0]],

    [41, [53, 0]],
    [44, [3, 240]],

    [46, [69, 0]],
    [45, [68, 0]],
    [47, [74, 0]],
    [48, [77, 0]],

    [19, [71, 0]],
    [22, [2, 241]],
    [227, [9, 243]],
    [228, [2, 240]],
    [51, [70, 0]],

    [52, [72, 0]],
    [4, [1, 241]], // a
  ])

  private POLAR75FnDisableKeys: Map<KK, number[]> = new Map([
    [0x3a, [0x94, 0x11]],
    [0x3b, [0x23, 0x12]],
    [0x3c, [0x8a, 0x11]],
    [0x3d, [0x83, 0x11]],
    [0x3e, [0xb6, 0x10]],
    [0x3f, [0xb5, 0x10]],
    [0x3f, [0xb5, 0x10]],
    [0x40, [0xcd, 0x10]],
    [0x41, [0xb7, 0x10]],
    [0x42, [0xe9, 0x10]],
    [0x43, [0xea, 0x10]],
    [0x44, [0xe2, 0x10]],
    [0x45, [0x92, 0x10]],
    [0x4c, [0x00, 0xf1]],
    [0x4c, [0x00, 0xf1]],
    [0x49, [0x17, 0xf3]],
    [0x4b, [0x10, 0xf3]],
    [0x4e, [0x11, 0xf3]],
    [0x4e, [0x11, 0xf3]],
    [0x04, [0x01, 0xf1]],
    [0xe3, [0x09, 0xf3]],
    [0x52, [0x12, 0xf3]],
    [0x51, [0x13, 0xf3]],
    [0x50, [0x15, 0xf3]],
    [0x4f, [0x14, 0xf3]],
  ])

  // 第一位是功能，第二位是类型
  private mg75FnDisableKeys: Map<KK, number[]> = new Map([
    [0x3a, [0x94, 0x11]],
    [0x3b, [0x23, 0x12]],
    [0x3c, [0x8a, 0x11]],
    [0x3d, [0x83, 0x11]],
    [0x3e, [0xb6, 0x10]],
    [0x3f, [0xb5, 0x10]],
    [0x40, [0xcd, 0x10]],
    [0x41, [0xb7, 0x10]],
    [0x42, [0xe9, 0x10]],
    [0x43, [0xea, 0x10]],
    [0x44, [0xe2, 0x10]],
    [0x45, [0x92, 0x11]],
    [0x2a, [0x17, 0xf3]],
    [0x2f, [0x10, 0xf3]],

    [0x16, [0x02, 0xf1]],
    [0xe3, [0x09, 0xf3]],
    [0xe6, [0x02, 0xf0]],
    [0x52, [0x12, 0xf3]],
    [0x51, [0x13, 0xf3]],
    [0x50, [0x15, 0xf3]],
    [0x4f, [0x14, 0xf3]],
    [0x30, [0x39, 0xf3]],
  ])

  private mer68FnDisableKeys: Map<KK, number[]> = new Map([
    [0x1e, [0x3a, 0x00]],
    [0x1f, [0x3b, 0x00]],
    [0x20, [0x3c, 0x00]],
    [0x21, [0x3d, 0x00]],
    [0x22, [0x3e, 0x00]],
    [0x23, [0x3f, 0x00]],
    [0x24, [0x40, 0x00]],
    [0x25, [0x41, 0x00]],
    [0x26, [0x42, 0x00]],
    [0x27, [0x43, 0x00]],
    [0x2d, [0x44, 0x00]],
    [0x2e, [0x45, 0x00]],
    [0x2a, [0x17, 0xf3]],

    [0x04, [0x01, 0xf1]], // win
    [0x16, [0x02, 0xf1]], // max
    [0x2f, [0x10, 0xf3]],

    [0x16, [0x02, 0xf1]],
    [0xe3, [0x09, 0xf3]],
    [0xe6, [0x02, 0xf0]],
    [0x52, [0x12, 0xf3]],
    [0x51, [0x13, 0xf3]],
    [0x50, [0x15, 0xf3]],
    [0x4f, [0x14, 0xf3]],
    [0x30, [0x39, 0xf3]],
  ])

  getFnDisableKeysData(device: DefineDevice): Map<number, number[]> {
    if (device == VirtualMu68Pro || device == VirtualMu68Pro_Cyan) {
      return this.Mu68ProFnDisableKeys
    } else if (device == VirtualMu68_ULTRA) {
      return this.Mu68ULTRAFnDisableKeys
    } else if (device == VirtualPolar75) {
      return this.POLAR75FnDisableKeys
    } else if (JingTaiMg75Devices.includes(device)) {
      return this.mg75FnDisableKeys
    } else if (JingTaiMer68Devices.includes(device)) {
      return this.mer68FnDisableKeys
    } else if (device == VirtualNa87ProWired) {
      return this.Na87ProFnDisableKeys
    } else if (device == VirtualNd63 || device == VirtualNd63_Cyan) {
      return this.ND63FnDisableKeys
    } else {
      throw new Error('Not Found Device : ' + device)
    }
  }
}

export const na87Data = new Na87()

export const enum na87Layout {
  FN0 = 0x00,
  FN1 = 0x01,
  FN2 = 0x02,
  FN3 = 0x03,
  DB0 = 0x04,
  DB1 = 0x05,
  DB2 = 0x06,
  DB3 = 0x07,
  MODE = 0x08,
  DKS1 = 0x09,
  DKS2 = 0x0a,
  DKS3 = 0x0b,
  DKS4 = 0x0c,
  TRPS1 = 0x0d,
  TRPS2 = 0x0e,
  TRPS3 = 0x0f,
  TRPS4 = 0x10,
  Macro_addr = 0x11,
  Macro_long = 0x12,
  MT_TGL = 0x13,
  RT_press = 0x14,
  RT_release = 0x15,
}

const enum na87SetMode {
  global = 0x00,
  single = 0x01,
  RT = 0x02,
  MT = 0x03,
  TGL = 0x04,
  DKS = 0x20,
  MPT = 0x21,
  END = 0x05,
  Macro = 0x06,
  Combi = 0x10,
  longPress = 0x80,
}
